module.exports = __webpack_public_path__ + "assets/img/thumb-Discover-Massage-Australia-eBook.f0cf7404.webp";